import { render, staticRenderFns } from "./SubCampaign.vue?vue&type=template&id=71170b3a"
import script from "./SubCampaign.vue?vue&type=script&lang=js"
export * from "./SubCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports